import React, {  Suspense } from "react";
import Observer from '@researchgate/react-intersection-observer';
import LoaderDisplay from './loaderDisplay';

const IntersectionLazyLoader = ({ beforeLoad, children }) => {
    const [show, setShow] = React.useState(false);

    const handleIntersection = (event) => {
        if (event.isIntersecting) {
            setShow(true);
        }
    }

    const options = {
        onChange: handleIntersection,
        rootMargin: "200px 0px 200px 0px",
    };

    if (!show) return (
        <Observer {...options}>
            <div id="observer-anchor">{beforeLoad}</div>
        </Observer>);
    else {
        return (
            <Suspense fallback={<LoaderDisplay />}>
                {children}
            </Suspense>
        );
    }
    
};

export default IntersectionLazyLoader;
